export default __webpack_public_path__ + "static/media/section2-bg3.09bc4f8b.png";